// import { StorageService } from './storage.service';
import { DashboardService } from './dashboard.service';
import { NotificationService } from './notification.service';
import { UserService } from './user.service';
import { WorkingService } from './working.service';

// export * from './storage.service';
export * from './notification.service';
export * from './user.service';
export * from './working.service';

export const SHARED_SERVICES = [
  // StorageService,
  NotificationService,
  UserService,
  DashboardService,
  WorkingService,
];
